import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzListModule } from "ng-zorro-antd/list";
import { NzMessageModule } from "ng-zorro-antd/message";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { SharedModule } from "../../shared/shared.module";
import { HeaderFullscreenComponent } from "./header-fullscreen/header-fullscreen.component";
import { HeaderNotifyComponent } from "./header-notify/header-notify.component";
import { HeaderUserComponent } from "./header-user/header-user.component";
import { HeaderComponent } from "./header.component";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzDrawerModule } from "ng-zorro-antd/drawer";

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderFullscreenComponent,
    HeaderNotifyComponent,
    HeaderUserComponent,
  ],
  exports: [HeaderComponent],
  imports: [
    NzModalModule,
    CommonModule,
    NzDividerModule,
    NzAvatarModule,
    NzDropDownModule,
    NzDrawerModule,
    NzButtonModule,
    NzMenuModule,
    NzIconModule,

    NzDescriptionsModule,
    NzMessageModule,
    NzDropDownModule,
    NzSpinModule,
    NzListModule,
    NzBadgeModule,
    NzTabsModule,
    SharedModule,
    RouterModule,
    NzTableModule,
    NzFormModule,
    NzSelectModule,
    NzInputModule,
    NzPopconfirmModule,
  ],
})
export class HeaderModule {}
